import { ChevronLeft, ChevronRight } from 'lucide-react';

export default function Pagination({ page, limit, total, onChange }) {
  const totalPages = Math.max(1, Math.ceil((total || 0) / (limit || 20)));
  if (totalPages <= 1) return null;
  return (
    <div className="flex items-center justify-between mt-4">
      <div className="text-sm text-slate-500">
        Page {page} of {totalPages} · {total} items
      </div>
      <div className="flex items-center gap-1">
        <button
          className="btn-secondary px-2 py-1.5"
          disabled={page <= 1}
          onClick={() => onChange(page - 1)}
        >
          <ChevronLeft size={16} />
        </button>
        <button
          className="btn-secondary px-2 py-1.5"
          disabled={page >= totalPages}
          onClick={() => onChange(page + 1)}
        >
          <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );
}
